'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.hourBefore;


// WEBPACK FOOTER //
// ./~/sugar-date/number/hourBefore.js